import { DESTINATION_TYPES } from '../../../constants';
import type { BillingType } from '../../../types';

/** Returns whether a string is a supported billing form type. */
export function isBillingType(value: string): value is BillingType {
  return value === DESTINATION_TYPES.PRIVATE || value === DESTINATION_TYPES.COMPANY;
}
